import { render } from "./ResultsDetailItem.vue?vue&type=template&id=5684313e"
import script from "./ResultsDetailItem.vue?vue&type=script&lang=js"
export * from "./ResultsDetailItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__